import React, { memo } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

const FormLabel = memo(({ label, text = "전체기간", check, onChange }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          {...label}
          checked={check}
          onChange={(e) => onChange(e)}
          sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
        />
      }
      label={
        <Typography
          textAlign="center"
          variant="body"
          component="div"
          fontWeight={500}
        >
          {text}
        </Typography>
      }
    />
  );
});

FormLabel.propTypes = {
  label: PropTypes.object,
  text: PropTypes.string || null,
  check: PropTypes.bool,
  onChange: PropTypes.func,
};

export default FormLabel;
